import WecomCommand from "./wecom-command";
import WechatCommand from "./wechat-command";
import WhatsAppCommand from "./whatsapp-command";

const Command = {
  WecomCommand,
  WechatCommand,
  WhatsAppCommand,
};

export default Command;
